<template>
  <div class="sidebar">
    <div class="sidebar-header">
      <div class="row mx-0">
        <div class="col-12 px-0 hand-pointer" @click="logoutLocal">
          <img
            class="sidebar-logout float-l pt-1"
            src="/assets/icons/primary/logout.svg"
            alt=""
          />
          <p class="sidebar-header-logout t-secondary t-uppercase mb-2 pl-1 ml-4 apercu-medium">
            log out
          </p>
        </div>
        <account-new-header/>
      </div>
    </div>
    <div class="sidebar-body">
      <div
        class="row mx-0"
        v-for="(route, index) in routes_to_show"
        :key="route.id"
      >
        <router-link
          :class="{'sidebar-link col-12 px-0 d-flex': true, 'sidebar-link-active': routePath.startsWith(route.link)}"
          :to="route.link"
          style="height: 50px"
        >
          <div class="my-auto">
            <h5 class="t-uppercase mb-0">
              {{ route.name }}
            </h5>
          </div>
        </router-link>
        <hr v-if="index !== routes_to_show.length - 1" class="divider"/>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthUser } from '../../utils/stores/modules/authUser'
import accountNewHeader from './views/accountNewHeader.vue';

const userStore = useAuthUser()
const router = useRouter()
// Props (defineProps)
const props = defineProps({
  routePath: {
    type: String,
    required: true,
  }
})
// Emits (defineEmits)
// Reactive variables (inc composables)
const routes = ref([
  {
    id: 1,
    link: '/account/my-subscription',
    name: 'your subscription',
    isActive: false,
  },
  {
    id: 2,
    link: '/account/order-history',
    name: 'order history',
    isActive: false,
  },
  {
    id: 3,
    link: '/account/rate-coffees',
    name: 'rate coffees',
    isActive: false,
  },
  {
    id: 4,
    link: '/account/details',
    name: 'account details',
    isActive: false,
  },
  {
    id: 5,
    link: '/account/share-a-coffee',
    name: 'Refer a Friend',
    isActive: false,
  },
  {
    id: 6,
    link: '/account/contact-us',
    name: 'contact us',
    isActive: false,
  }
])
// Computed
const routes_to_show = computed(() => routes.value)
// Methods
function logoutLocal() {
  userStore.logout({ callback: goLogin })
}
function goLogin(response) {
  if (response.status === 'ok') router.push('/login')
}
// Watchers
// Lifecycle Hooks
// Expose (defineExpose)
</script>

<script>
export default {
	name: 'AccountSidebarDesktop',
}
</script>

<style lang="scss">
</style>
